import React from 'react';
import { Pulldown } from 'jbc-front/components/icons';
import styles from './PayrollTableData.scss';

const AccordionRow = props => {
  const { label, value, isRowClick, accordionHandler } = props;
  const iconStyle = isRowClick ? styles.iconClosed : styles.iconOpen;

  return (
    <tr className={styles.accordionRow}>
      <th>{label}</th>
      <td>
        {value}
        <Pulldown size={10} className={iconStyle} onClick={accordionHandler} />
      </td>
    </tr>
  );
};

export default AccordionRow;
